// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Row$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as CountryConfig from "../../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as CountryContext from "../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as Column$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Column.bs.js";
import * as Navbar$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/navbar/Navbar.bs.js";
import * as WalletListViewSections from "../../components/wallet-list/WalletListViewSections.bs.js";
import * as LoadingViewComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/LoadingViewComponent.bs.js";
import * as PartnerWalletAdminTransactionModal from "../../components/wallet-list/PartnerWalletAdminTransactionModal.bs.js";

function getBalanceAmount(walletReport) {
  if (typeof walletReport === "number") {
    return ;
  }
  switch (walletReport.TAG | 0) {
    case /* Loading */0 :
        var report = walletReport._0;
        if (report !== undefined) {
          return report.balanceAmount;
        } else {
          return ;
        }
    case /* Live */1 :
        return walletReport._0.balanceAmount;
    case /* Error */2 :
        return ;
    
  }
}

function getBalanceAmountText(balance, country) {
  if (balance === undefined) {
    return "NA";
  }
  var balance$1 = balance.toString();
  return CountryConfig.getSymbol(country) + balance$1;
}

function getAdminTransactionModalSection(showCreateTransactionModal, createPartnerWalletTransaction, closeCreateTransactionModal, refreshWalletReport, createTransactionStatus) {
  if (showCreateTransactionModal) {
    return React.createElement(PartnerWalletAdminTransactionModal.make, {
                createPartnerWalletTransaction: createPartnerWalletTransaction,
                closeCreateTransactionModal: closeCreateTransactionModal,
                refreshWalletReport: refreshWalletReport,
                createTransactionStatus: createTransactionStatus
              });
  } else {
    return null;
  }
}

function getFixedLoadingView(param) {
  return React.createElement("div", {
              className: "fixed-loader-section"
            }, React.createElement(LoadingViewComponent$Catalyst.make, {}));
}

function WalletTransactionsReportViewMapper$WalletReportCmp(Props) {
  var state = Props.state;
  var onScrollEndCallback = Props.onScrollEndCallback;
  var onFiltersSubmit = Props.onFiltersSubmit;
  var createAdminTransaction = Props.createAdminTransaction;
  var openCreateTransactionModal = Props.openCreateTransactionModal;
  var closeCreateTransactionModal = Props.closeCreateTransactionModal;
  var refreshWalletReport = Props.refreshWalletReport;
  var match = CountryContext.useContext(undefined);
  var match$1 = state.report;
  var match$2 = state.createTransactionStatus;
  var tmp;
  var exit = 0;
  if (typeof match$1 === "number" || match$1.TAG !== /* Loading */0) {
    exit = 1;
  } else {
    tmp = getFixedLoadingView(undefined);
  }
  if (exit === 1) {
    tmp = typeof match$2 === "number" || match$2.TAG !== /* Loading */0 ? null : getFixedLoadingView(undefined);
  }
  return React.createElement("div", {
              className: "wallet-report"
            }, React.createElement(Column$Catalyst.make, {
                  children: null,
                  className: ""
                }, React.createElement(Navbar$Catalyst.make, {
                      title: "Wallet Balance",
                      navbar_item_first: {
                        label: "",
                        value: {
                          TAG: /* Text */0,
                          _0: getBalanceAmountText(getBalanceAmount(state.report), match.country)
                        }
                      },
                      actions: {
                        hd: {
                          label: {
                            TAG: /* Text */0,
                            _0: "Create Transaction"
                          },
                          on_select_cb: openCreateTransactionModal,
                          icon: undefined
                        },
                        tl: /* [] */0
                      }
                    }), React.createElement(Row$Catalyst.make, {
                      children: null,
                      className: "content"
                    }, React.createElement(WalletListViewSections.Sections.LeftContainer.make, {
                          filters: state.filters,
                          onFiltersSubmit: onFiltersSubmit
                        }), React.createElement(WalletListViewSections.Sections.RightContainer.make, {
                          state: state,
                          onScrollEndCallback: onScrollEndCallback
                        }))), getAdminTransactionModalSection(state.showCreateTransactionModal, createAdminTransaction, closeCreateTransactionModal, refreshWalletReport, state.createTransactionStatus), tmp);
}

var WalletReportCmp = {
  make: WalletTransactionsReportViewMapper$WalletReportCmp
};

function getView(state, onScrollEndCallback, onFiltersSubmit, createAdminTransaction, openCreateTransactionModal, closeCreateTransactionModal, refreshWalletReport) {
  return React.createElement(WalletTransactionsReportViewMapper$WalletReportCmp, {
              state: state,
              onScrollEndCallback: onScrollEndCallback,
              onFiltersSubmit: onFiltersSubmit,
              createAdminTransaction: createAdminTransaction,
              openCreateTransactionModal: openCreateTransactionModal,
              closeCreateTransactionModal: closeCreateTransactionModal,
              refreshWalletReport: refreshWalletReport
            });
}

export {
  getBalanceAmount ,
  getBalanceAmountText ,
  getAdminTransactionModalSection ,
  getFixedLoadingView ,
  WalletReportCmp ,
  getView ,
  
}
/* react Not a pure module */
